export default {
  QUESTION: 'Frage',
  QUESTION_TYPE: 'Fragentyp',
  EMPTY_OPTIONS: 'Bitte geben Sie einen Optionswert an.',
  FILL_REQUIRED_VALUES: 'Bitte füllen Sie alle erforderlichen Felder aus.',
  DELETE_QUESTION_POPUP_TITLE: 'Frage löschen?',
  DELETE_QUESTION_POPUP_LABEL:
    'Nach dem Löschen ist die Frage in der App nicht mehr sichtbar und muss erneut hinzugefügt werden, falls Sie sie zurückhaben möchten.',
  FORM_UPDATE_SUCCESS: 'Ihr Formular wurde erfolgreich aktualisiert!',
  CHOOSE_ANS_TYPE: 'Wählen Sie eine Antwort',
  SETUP_QUESTION: 'Qualifizierende Fragen einrichten',
  SETUP_QUESTION_INFO: 'Ändern Sie diese Fragen, um Ihre Leads zu qualifizieren. Änderungen werden in Ihrer App aktualisiert.',
  FIX_QUESTION_INFO: 'Diese Frage ist in der App obligatorisch und kann nicht bearbeitet oder geändert werden.',
  NEW_QUESTION_BTN: 'Klicken Sie hier, um ein neues Bundesland hinzuzufügen.'
}
